var _style, _circle, _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage04Layer1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 400",
    style: {
      enableBackground: "new 0 0 500 400"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{display:none}.st1{fill:#ffcd00}.st2{clip-path:url(#SVGID_2_)}.st3{fill:#ffeb00}.st4{fill:#fffd00}.st5{display:inline}.st6{fill:#00cbd8}.st7{fill:#02cbd8}")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      display: "inline",
      overflow: "visible",
      enableBackground: "new"
    },
    width: 500,
    height: 400,
    xlinkHref: "EA28EA2A.jpeg",
    transform: "matrix(1 0 0 1 0 -6.728313e-06)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 241.4,
    cy: 198.8,
    r: 182.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 241.4,
    cy: 198.8,
    r: 182.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M25.3 99.3l-9.2-8.1c-5 5.7-9.6 11.6-13.9 17.8l10.1 7C16.3 110.2 20.7 104.6 25.3 99.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M70 61.8l-6.3-10.5c-13.1 8-25.3 17.4-36.3 28L36 88C46.2 78 57.7 69.2 70 61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M167.8 34.5V22.3c-32.2.0-62.7 7.6-89.7 21l5.5 11C108.9 41.6 137.6 34.5 167.8 34.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-11.3 285-23 289c2.5 7.2 5.3 14.2 8.5 21l11.1-5.3C-6.3 298.3-9 291.7-11.3 285z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M3.9 129.2-6.7 123c-15.2 26.2-24.6 56.2-26.6 88.2l12.2.8C-19.4 183.8-11.2 155.4 3.9 129.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-21.4 227.5l-12.3.2c.3 15.6 2.4 30.9 6 45.4l11.9-3C-19.2 256.3-21.2 241.9-21.4 227.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M3.9 318.5l-10.6 6.1c15.6 27 37.3 50 63.1 67.2l6.8-10.2C39.5 366 19 344.7 3.9 318.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M76.4 389.6l-5.9 10.8c13.3 7.3 27.5 13.2 42.4 17.5l3.4-11.8C102.4 402 89 396.6 76.4 389.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M131.2 409.6l-2.4 12.1c7.3 1.4 14.8 2.5 22.4 3.1l1-12.2C145.2 411.9 138.2 410.9 131.2 409.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M265.6 385.9l6.4 10.5c13.2-8 25.3-17.4 36.3-28l-8.5-8.8C289.5 369.6 278 378.5 265.6 385.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M167.9 413.1v12.3c32.2.0 62.7-7.6 89.7-21l-5.5-11C226.8 406 198.1 413.1 167.9 413.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M310.4 348.4l9.2 8.1c5-5.7 9.6-11.6 13.9-17.8l-10.1-7C319.4 337.5 315 343.1 310.4 348.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M347 162.7l11.7-4c-2.5-7.2-5.3-14.2-8.5-21L339 143C342 149.4 344.7 156 347 162.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M331.8 318.5l10.6 6.1c15.2-26.2 24.6-56.2 26.6-88.2l-12.2-.8C355.1 263.9 346.9 292.3 331.8 318.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M357.1 220.2l12.3-.2c-.3-15.6-2.4-30.9-6-45.4l-11.9 3C354.9 191.4 356.9 205.8 357.1 220.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M204.5 38.1l2.4-12.1c-7.3-1.4-14.8-2.5-22.4-3.1l-1 12.2C190.5 35.8 197.5 36.7 204.5 38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M259.3 58.1l5.9-10.8C252 40 237.8 34.1 222.9 29.9l-3.4 11.8C233.3 45.6 246.7 51.1 259.3 58.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M331.8 129.2l10.6-6.1c-15.6-27-37.3-50-63.1-67.2l-6.8 10.2C296.2 81.7 316.6 103 331.8 129.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M31.6 271.8c4.3-2.4 18.2-12.9 18.2-47.2.0-9.5 1.1-18.9 3.3-28 .8-3.4-1.3-6.8-4.6-7.6-3.4-.8-6.8 1.3-7.6 4.6-2.4 10.1-3.7 20.5-3.7 31 0 26.8-9.5 34.7-11.5 36.1-3 1-5.8 2.2-8.6 3.5 1.1 4.1 2.3 8.1 3.8 12.1 3.1-1.5 6.3-2.8 9.6-4C30.9 272.1 31.3 272 31.6 271.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M102.4 241.3c.4-3.4-2.1-6.5-5.6-6.9-3.4-.4-6.5 2.1-6.9 5.6-5.8 54-41.1 66.9-42.4 67.4-3.1 1-6.1 2.2-8.9 3.7 2.4 3.5 4.9 6.9 7.6 10.2 1.7-.8 3.5-1.5 5.3-2.1C53.3 318.6 95.8 303.1 102.4 241.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M108.8 303.6c1.9-2.9 1.1-6.8-1.8-8.7s-6.8-1.1-8.7 1.8c-17.4 26.4-40.5 34.1-41.4 34.4-.5.2-1.1.4-1.6.6 3.2 3.3 6.5 6.5 10 9.6C74.2 337.4 93.4 326.9 108.8 303.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M41.8 295.4c5.8-2.3 34.7-16.8 34.7-70.9.0-41.4 26.5-77.4 66-89.7 3.3-1 5.1-4.5 4.1-7.8-1-3.3-4.5-5.2-7.8-4.1C94.1 136.8 64 177.7 64 224.5c0 46.3-23.3 57.8-26.7 59.2-3.9 1.3-7.7 2.9-11.3 4.8 1.7 3.8 3.6 7.5 5.7 11.2 3.1-1.6 6.4-3 9.8-4.1C41.5 295.5 41.7 295.5 41.8 295.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M147.4 284.6c3.2-9.4 5.6-19.5 7.2-30 .5-3.4-1.9-6.6-5.3-7.1-3.4-.5-6.6 1.9-7.1 5.3-1.4 9.7-3.7 19.1-6.6 27.8-14.3 42-43.1 61.8-58.8 69.8 3.8 2.8 7.8 5.3 11.8 7.7C106.8 347.4 133.5 325.5 147.4 284.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M181.8 224.5c0-3.5-2.8-6.3-6.3-6.3-3.5.0-6.3 2.8-6.3 6.3.0 52.1-16 93.9-47.7 124.2-6.9 6.6-13.8 11.9-20.2 16.1 4.5 2.1 9 4 13.7 5.7 4.8-3.5 9.7-7.6 14.7-12.4C153.5 335.7 181.8 294.2 181.8 224.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M185.4 308.7c-3.2-1.4-6.9.0-8.3 3.2-9.4 21.2-22.4 39.9-38.7 55.4-2.9 2.8-5.8 5.3-8.7 7.7 5.1 1.3 10.2 2.3 15.5 3.1.6-.6 1.2-1.1 1.8-1.7 17.5-16.7 31.5-36.7 41.6-59.4C190 313.8 188.5 310.1 185.4 308.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M190.9 184.1c3.2 1.3 6.9-.1 8.2-3.3 1.3-3.2-.2-6.9-3.3-8.2-7-2.9-14.4-4.4-21.9-4.4-31.1.0-56.4 25.3-56.4 56.4.0 15.3-1.9 29.6-5.6 42.4-1 3.3 1 6.8 4.3 7.8.6.2 1.2.3 1.8.3 2.7.0 5.2-1.8 6-4.5 4-13.9 6.1-29.3 6.1-45.9.0-24.2 19.7-43.8 43.9-43.8C179.7 180.7 185.5 181.8 190.9 184.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M192.5 287.8c.5.1 1 .2 1.5.2 2.8.0 5.4-1.9 6.1-4.8 4.5-18.3 6.8-38.1 6.8-58.7.0-17.3-14-31.3-31.3-31.3-17.3.0-31.3 14-31.3 31.3.0 3.5 2.8 6.3 6.3 6.3s6.3-2.8 6.3-6.3c0-10.4 8.4-18.8 18.8-18.8 10.4.0 18.8 8.4 18.8 18.8.0 19.6-2.2 38.4-6.4 55.7C187 283.6 189.1 287 192.5 287.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M224.4 199.6c-1.5-3.1-5.3-4.4-8.4-2.8-3.1 1.5-4.4 5.3-2.8 8.4 3 6.1 4.5 12.6 4.5 19.4.0 77.3-30.1 126.3-57.8 155 2.6.1 5.3.2 7.9.2 3.1.0 6.1-.1 9.1-.3 26.8-31.2 53.3-80.8 53.3-154.9C230.2 215.8 228.2 207.4 224.4 199.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M234.1 312.3c-3.2-1.1-6.8.5-8 3.8-8 22.6-19.2 43.2-33.3 61.6 6.3-1 12.4-2.4 18.4-4.1 11-16.3 19.9-34.2 26.7-53.3C239.1 317 237.4 313.5 234.1 312.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M244.1 270c.3.0.5.0.8.0 3.1.0 5.8-2.3 6.2-5.5 1.6-12.9 2.5-26.4 2.5-40 0-44.9-36.5-81.4-81.4-81.4-39 0-72.7 27.8-80 66.1-.6 3.4 1.6 6.7 5 7.3 3.4.6 6.7-1.6 7.3-5 6.2-32.4 34.7-55.9 67.7-55.9 38 0 68.9 30.9 68.9 68.9.0 13.1-.8 26.1-2.4 38.4C238.2 266.4 240.7 269.6 244.1 270z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M251.1 155c-16.5-19.1-39.3-31.8-64.1-35.7-3.4-.5-6.6 1.8-7.1 5.2-.5 3.4 1.8 6.6 5.2 7.2 45.3 7 79.5 47 79.5 92.8.0 61.1-15.9 108.1-36.5 143.2 6.8-2.8 13.3-6.1 19.6-9.9 17.1-34.6 29.4-78.5 29.4-133.3C277 199 267.8 174.3 251.1 155z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M269 160.4c1.2 1.8 3.2 2.9 5.3 2.9 1.2.0 2.3-.3 3.4-1 2.9-1.9 3.7-5.7 1.9-8.7C255.2 115.7 213.8 93 168.8 93c-42.6.0-82.7 20.8-107.4 55.7-2 2.8-1.3 6.7 1.5 8.7 2.8 2 6.7 1.3 8.7-1.5 22.3-31.6 58.7-50.4 97.2-50.4C209.5 105.5 247 126 269 160.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M171.2 68c-1.1.0-2.2.0-3.4.0h-.3c-86 .2-155.6 69.9-155.6 155.9.0 9.3.8 18.3 2.4 27.2.5-.2.9-.4 1.4-.6 1.4-.5 2.5-1.6 3.2-2.9 1.9-3.6 4.1-10.5 4.1-23 0-79.5 64.6-144.1 144.1-144.1s144.1 64.6 144.1 144.1c0 27.8-2.8 53.2-7.8 76.2 12.8-22.6 20.2-48.7 20.3-76.6v-.4C323.8 138.8 255.8 69.8 171.2 68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M294.1 218.3c-3.5.0-6.3 2.8-6.3 6.3.0 48-9.1 88.1-22.6 121.1 7.4-5.9 14.2-12.5 20.4-19.6 9.1-29.2 14.8-62.9 14.8-101.5C300.4 221.1 297.6 218.3 294.1 218.3z"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 72,
    cy: 8.7,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 72,
    cy: 41.3,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 72,
    cy: 73.9,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 72,
    cy: 106.5,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 72,
    cy: 139.1,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 72,
    cy: 171.6,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 72,
    cy: 204.2,
    r: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M96.4 8.7c0 1.6 1.3 2.8 2.8 2.8 1.6.0 2.8-1.3 2.8-2.8s-1.3-2.8-2.8-2.8C97.7 5.9 96.4 7.2 96.4 8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M96.4 41.3c0 1.6 1.3 2.8 2.8 2.8 1.6.0 2.8-1.3 2.8-2.8s-1.3-2.8-2.8-2.8C97.7 38.5 96.4 39.8 96.4 41.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M96.4 73.9c0 1.6 1.3 2.8 2.8 2.8 1.6.0 2.8-1.3 2.8-2.8.0-1.6-1.3-2.8-2.8-2.8C97.7 71.1 96.4 72.3 96.4 73.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M96.4 106.5c0 1.6 1.3 2.8 2.8 2.8 1.6.0 2.8-1.3 2.8-2.8.0-1.6-1.3-2.8-2.8-2.8C97.7 103.6 96.4 104.9 96.4 106.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M96.4 139.1c0 1.6 1.3 2.8 2.8 2.8 1.6.0 2.8-1.3 2.8-2.8s-1.3-2.8-2.8-2.8C97.7 136.2 96.4 137.5 96.4 139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M96.4 171.6c0 1.6 1.3 2.8 2.8 2.8 1.6.0 2.8-1.3 2.8-2.8s-1.3-2.8-2.8-2.8C97.7 168.8 96.4 170.1 96.4 171.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M96.4 204.2c0 1.6 1.3 2.8 2.8 2.8 1.6.0 2.8-1.3 2.8-2.8s-1.3-2.8-2.8-2.8C97.7 201.4 96.4 202.7 96.4 204.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M123.6 8.7c0 1.6 1.3 2.8 2.8 2.8 1.6.0 2.8-1.3 2.8-2.8s-1.3-2.8-2.8-2.8C124.8 5.9 123.6 7.2 123.6 8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M123.6 41.3c0 1.6 1.3 2.8 2.8 2.8 1.6.0 2.8-1.3 2.8-2.8s-1.3-2.8-2.8-2.8C124.8 38.5 123.6 39.8 123.6 41.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M123.6 73.9c0 1.6 1.3 2.8 2.8 2.8 1.6.0 2.8-1.3 2.8-2.8.0-1.6-1.3-2.8-2.8-2.8C124.8 71.1 123.6 72.3 123.6 73.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M123.6 106.5c0 1.6 1.3 2.8 2.8 2.8 1.6.0 2.8-1.3 2.8-2.8.0-1.6-1.3-2.8-2.8-2.8C124.8 103.6 123.6 104.9 123.6 106.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M123.6 139.1c0 1.6 1.3 2.8 2.8 2.8 1.6.0 2.8-1.3 2.8-2.8s-1.3-2.8-2.8-2.8C124.8 136.2 123.6 137.5 123.6 139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M123.6 171.6c0 1.6 1.3 2.8 2.8 2.8 1.6.0 2.8-1.3 2.8-2.8s-1.3-2.8-2.8-2.8C124.8 168.8 123.6 170.1 123.6 171.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M123.6 204.2c0 1.6 1.3 2.8 2.8 2.8 1.6.0 2.8-1.3 2.8-2.8s-1.3-2.8-2.8-2.8C124.8 201.4 123.6 202.7 123.6 204.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 153.6,
    cy: 8.7,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 153.6,
    cy: 41.3,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 153.6,
    cy: 73.9,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 153.6,
    cy: 106.5,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 153.6,
    cy: 139.1,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 153.6,
    cy: 171.6,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 153.6,
    cy: 204.2,
    r: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M178 8.7c0 1.6 1.3 2.8 2.8 2.8s2.8-1.3 2.8-2.8-1.3-2.8-2.8-2.8C179.2 5.9 178 7.2 178 8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M178 41.3c0 1.6 1.3 2.8 2.8 2.8s2.8-1.3 2.8-2.8-1.3-2.8-2.8-2.8C179.2 38.5 178 39.8 178 41.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M178 73.9c0 1.6 1.3 2.8 2.8 2.8s2.8-1.3 2.8-2.8c0-1.6-1.3-2.8-2.8-2.8C179.2 71.1 178 72.3 178 73.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M178 106.5c0 1.6 1.3 2.8 2.8 2.8s2.8-1.3 2.8-2.8c0-1.6-1.3-2.8-2.8-2.8C179.2 103.6 178 104.9 178 106.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M178 139.1c0 1.6 1.3 2.8 2.8 2.8s2.8-1.3 2.8-2.8-1.3-2.8-2.8-2.8C179.2 136.2 178 137.5 178 139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M178 171.6c0 1.6 1.3 2.8 2.8 2.8s2.8-1.3 2.8-2.8-1.3-2.8-2.8-2.8C179.2 168.8 178 170.1 178 171.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M178 204.2c0 1.6 1.3 2.8 2.8 2.8s2.8-1.3 2.8-2.8-1.3-2.8-2.8-2.8C179.2 201.4 178 202.7 178 204.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 208,
    cy: 8.7,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 208,
    cy: 41.3,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 208,
    cy: 73.9,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 208,
    cy: 106.5,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 208,
    cy: 139.1,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 208,
    cy: 171.6,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 208,
    cy: 204.2,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 235.2,
    cy: 8.7,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 235.2,
    cy: 41.3,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 235.2,
    cy: 73.9,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 235.2,
    cy: 106.5,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 235.2,
    cy: 139.1,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 235.2,
    cy: 171.6,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 235.2,
    cy: 204.2,
    r: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M259.5 8.7c0 1.6 1.3 2.8 2.8 2.8s2.8-1.3 2.8-2.8-1.3-2.8-2.8-2.8C260.8 5.9 259.5 7.2 259.5 8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M259.5 41.3c0 1.6 1.3 2.8 2.8 2.8s2.8-1.3 2.8-2.8-1.3-2.8-2.8-2.8C260.8 38.5 259.5 39.8 259.5 41.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M259.5 73.9c0 1.6 1.3 2.8 2.8 2.8s2.8-1.3 2.8-2.8c0-1.6-1.3-2.8-2.8-2.8C260.8 71.1 259.5 72.3 259.5 73.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M259.5 106.5c0 1.6 1.3 2.8 2.8 2.8s2.8-1.3 2.8-2.8c0-1.6-1.3-2.8-2.8-2.8C260.8 103.6 259.5 104.9 259.5 106.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M259.5 139.1c0 1.6 1.3 2.8 2.8 2.8s2.8-1.3 2.8-2.8-1.3-2.8-2.8-2.8C260.8 136.2 259.5 137.5 259.5 139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M259.5 171.6c0 1.6 1.3 2.8 2.8 2.8s2.8-1.3 2.8-2.8-1.3-2.8-2.8-2.8C260.8 168.8 259.5 170.1 259.5 171.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M259.5 204.2c0 1.6 1.3 2.8 2.8 2.8s2.8-1.3 2.8-2.8-1.3-2.8-2.8-2.8C260.8 201.4 259.5 202.7 259.5 204.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M394.8 17.4H383.5V6.1H372.8V17.4H361.5V28.1H372.8V39.4H383.5V28.1H394.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M394.8 103.5H383.5V92.2H372.8V103.5H361.5V114.2H372.8V125.5H383.5V114.2H394.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M467.3 17.4H456V6.1H445.3V17.4H434V28.1H445.3V39.4H456V28.1H467.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M467.3 103.5H456V92.2H445.3V103.5H434V114.2H445.3V125.5H456V114.2H467.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage04Layer1);
export default __webpack_public_path__ + "static/media/image-04-layer-1.577f8c7ffe47d1bb10924160868368cb.svg";
export { ForwardRef as ReactComponent };